import { getDateRangeValue } from '../../../../packages/JsonQuery';
import { IJsonQuery } from '../../../../packages/api-models/common/json_query';
import { TChatDates } from '../../utils/buildChatSrc';

export function getChatDates(jsonQuery: IJsonQuery | null): TChatDates | null {
  try {
    const range = jsonQuery ? getDateRangeValue('dates')(jsonQuery) : null;

    return range ? { checkin: range.gte, checkout: range.lt } : null;
  } catch {
    return null;
  }
}
